import React from "react";
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {BreadcrumbItem, Breadcrumb} from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Eresources = () =>{
  
  return (
    <div className="Eresources">
    
      <section className="inner-banner banner-align">
        <img className="img-fluid" src="/assets/img/innerbanner/E-Resources-banner-image.jpg" alt=""/>
      </section>
      <section  className="research-box-area">
           <Container>
              <Breadcrumb>
                <BreadcrumbItem>
                  <Link as={Link} to="/">
                         Home
                  </Link>
                  
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link as={Link} to="/ResearchToolCollections">
                      Research Tool Collections
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active>E-Resources</BreadcrumbItem>
              </Breadcrumb>
              <div className='information-content'>
                <h2>E-Resources</h2>
                <p>THe HU LICS has access to the following online research databases:</p>
              </div>
              <Row>
                  <Col lg={4} sm={6} className="border-bottom">
                    <div className="research-box">
                      <img src="/assets/img/researchtool/eresources/Power-and-Energy-Magazine.png" alt=""/>
                      <div className="subjects">
                        <p><b>Coverage:</b> All volumes from 2003 tilvl 2022</p>
                        <p><b>Useful for:</b> DSSE</p>
                        <p><b>Subject Coverage:</b></p>
                      </div>
                      <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="border-end border-start border-bottom">
                    <div className="research-box">
                      <img src="/assets/img/researchtool/eresources/Wireless-Communication.png" alt=""/>
                      <div className="subjects">
                        <p><b>Coverage:</b> All volumes from 2003 till 2022</p>
                        <p><b>Useful for:</b> DSSE</p>
                        <p><b>Subject Coverage:</b></p>
                      </div>
                      <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="border-bottom">
                    <div className="research-box">
                      <img src="/assets/img/researchtool/eresources/Transaction-on-Circuits-and-Systems.png" alt=""/>
                      <div className="subjects">
                        <p><b>Coverage:</b> All volumes from 2003 till 2022</p>
                        <p><b>Useful for:</b> DSSE</p>
                        <p><b>Subject Coverage:</b></p>
                      </div>
                      <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="border-bottom">
                    <div className="research-box">
                      <img src="/assets/img/researchtool/eresources/Transaction-on-Games.png" alt=""/>
                      <div className="subjects">
                        <p><b>Coverage:</b> All volumes from 2003 till 2022</p>
                        <p><b>Useful for:</b> DSSE</p>
                        <p><b>Subject Coverage:</b></p>
                      </div>
                      <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="border-end border-start border-bottom">
                    <div className="research-box">
                      <img src="/assets/img/researchtool/eresources/taylor-logo.png" alt=""/>
                      <div className="subjects">
                        <p><b>Coverage:</b> All volumes from 2003 till 2022</p>
                        <p><b>Useful for:</b> DSSE</p>
                        <p><b>Subject Coverage:</b></p>
                      </div>
                      <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="border-bottom">
                    <div className="research-box">
                      <img src="/assets/img/researchtool/eresources/ProQuest-Dissertations.png" alt=""/>
                      <div className="subjects">
                        <p><b>Coverage:</b> All volumes from 2003 till 2022</p>
                        <p><b>Useful for:</b> DSSE</p>
                        <p><b>Subject Coverage:</b></p>
                      </div>
                      <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="border-bottom">
                    <div className="research-box">
                      <img src="/assets/img/researchtool/eresources/Communication-of-the-ACM.png" alt=""/>
                      <div className="subjects">
                        <p><b>Coverage:</b> All volumes from 2003 till 2022</p>
                        <p><b>Useful for:</b> DSSE</p>
                        <p><b>Subject Coverage:</b></p>
                      </div>
                      <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="border-end border-start border-bottom">
                    <div className="research-box">
                      <img src="/assets/img/researchtool/eresources/jstor.png" alt=""/>
                      <div className="subjects">
                        <p><b>Coverage:</b> All volumes from 2003 till 2022</p>
                        <p><b>Useful for:</b> DSSE</p>
                        <p><b>Subject Coverage:</b></p>
                      </div>
                      <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="border-bottom">
                    <div className="research-box">
                      <img src="/assets/img/researchtool/eresources/jstor-sustainability.png" alt=""/>
                      <div className="subjects">
                        <p><b>Coverage:</b> All volumes from 2003 till 2022</p>
                        <p><b>Useful for:</b> DSSE</p>
                        <p><b>Subject Coverage:</b></p>
                      </div>
                      <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="border-bottom">
                    <div className="research-box">
                      <img src="/assets/img/researchtool/eresources/informs-logo.png" alt=""/>
                      <div className="subjects">
                        <p><b>Coverage:</b> All volumes from 2003 till 2022</p>
                        <p><b>Useful for:</b> DSSE</p>
                        <p><b>Subject Coverage:</b></p>
                      </div>
                      <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="border-end border-start border-bottom">
                    <div className="research-box">
                      <img src="/assets/img/researchtool/eresources/SIAM.png" alt=""/>
                      <div className="subjects">
                        <p><b>Coverage:</b> All volumes from 2003 till 2022</p>
                        <p><b>Useful for:</b> DSSE</p>
                        <p><b>Subject Coverage:</b></p>
                      </div>
                      <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="border-bottom">
                    <div className="research-box">
                      <img src="/assets/img/researchtool/eresources/wiley-logo.png" alt=""/>
                      <div className="subjects">
                        <p><b>Coverage:</b> All volumes from 2003 till 2022</p>
                        <p><b>Useful for:</b> DSSE</p>
                        <p><b>Subject Coverage:</b></p>
                      </div>
                      <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="border-bottom">
                    <div className="research-box">
                      <img src="/assets/img/researchtool/eresources/springer-logo.png" alt=""/>
                      <div className="subjects">
                        <p><b>Coverage:</b> All volumes from 2003 till 2022</p>
                        <p><b>Useful for:</b> DSSE</p>
                        <p><b>Subject Coverage:</b></p>
                      </div>
                      <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="border-end border-start border-bottom">
                    <div className="research-box">
                      <img src="/assets/img/researchtool/eresources/imf-e-library.png" alt=""/>
                      <div className="subjects">
                        <p><b>Coverage:</b> All volumes from 2003 till 2022</p>
                        <p><b>Useful for:</b> DSSE</p>
                        <p><b>Subject Coverage:</b></p>
                      </div>
                      <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="border-bottom">
                    <div className="research-box">
                      <img src="/assets/img/researchtool/eresources/chronicle.png" alt=""/>
                      <div className="subjects">
                        <p><b>Coverage:</b> All volumes from 2003 till 2022</p>
                        <p><b>Useful for:</b> DSSE</p>
                        <p><b>Subject Coverage:</b></p>
                      </div>
                      <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>
                      
                    </div>
                  </Col>
                  <Col lg={4} sm={6} className="border-end">
                    <div className="research-box">
                      <img src="/assets/img/researchtool/eresources/bloomsburry-logo.png" alt=""/>
                      <div className="subjects">
                        <p><b>Coverage:</b> All volumes from 2003 till 2022</p>
                        <p><b>Useful for:</b> DSSE</p>
                        <p><b>Subject Coverage:</b></p>
                      </div>
                      <p>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before final copy is available.</p>
                      
                    </div>
                  </Col>

              </Row>
           </Container>
      </section>
     
    </div>
  );
}
export default Eresources;